import { render, staticRenderFns } from "./Expert2Config.vue?vue&type=template&id=1885218d&scoped=true&"
import script from "./Expert2Config.vue?vue&type=script&lang=js&"
export * from "./Expert2Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885218d",
  null
  
)

export default component.exports